module.exports = __webpack_public_path__ + "static/media/Project1_Demo7.5e9e0e32.png";